import { FC } from 'react';
import cn from 'classnames';
import styles from './OrganizationLandscapesTemplate.module.css';
import { OrganizationLandscapesOrganism } from '../../organisms';
import BaseTemplate from '../BaseTemplate';
import { Container } from 'react-bootstrap';
import { Button } from '../../atoms';
import { LandscapeBuyerRelationType } from '../../../store/landscapeAPI/landscape/landscape-buyer-relation-type';
import OrganizationBaseEditTemplate from '../../../templates/OrganizationBaseEditTemplate';

interface TableItem {
  id: string;
  landscapeName: string;
  relationType: LandscapeBuyerRelationType;
}

interface OrganizationLandscapesTemplateProps {
  setShow: (show: boolean) => void;
  data: TableItem[];
  handleDelete: (id: string) => void;
}

const OrganizationLandscapesTemplate: FC<
  OrganizationLandscapesTemplateProps
> = ({ setShow, data, handleDelete }) => {
  return (
    <BaseTemplate>
      <Container>
        <OrganizationBaseEditTemplate>
          <div className={cn(styles.wrapper)}>
            <Button
              onClick={() => setShow(true)}
              className={styles.buttonBorder}
              variant="light"
            >
              Add Landscape
            </Button>
            <div className={cn(styles.wrapper)}>
              <OrganizationLandscapesOrganism
                data={data}
                handleDelete={handleDelete}
              />
            </div>
          </div>
        </OrganizationBaseEditTemplate>
      </Container>
    </BaseTemplate>
  );
};

export default OrganizationLandscapesTemplate;
